

























































































































































    import { Component, Vue, Watch } from 'vue-property-decorator';
    import ProgramItem from '@/components/prescriber/ProgramItem.vue';
    import ProgramSearchComponent from '@/components/ProgramSearchComponent.vue';
    import { fetchProgramsPrescriber, fetchProgramsPrescriberById } from '@/utils/filters';
    import ListModule from '../../store/ListModule';
    import MetaDatatable from '../../models/MetaDatatable';
    import ListLots from '@/components/prescriber/ListLots.vue';
    import { differenceBetweenObjects } from '@/utils/differenceBetweenObjects';
    import cloneDeep from 'lodash/cloneDeep';
    import union from 'lodash/union';
    import animateCSS from '@/utils/animateCSS';
    import FiltersModule from '@/store/FiltersModule';
    import MapModule from '@/store/MapModule';
    import Lot from '../../models/Lot';
    // Import retiré pour le lazy loading
    // import DenouncePopup from '@/components/prescriber/DenouncePopup.vue';
    import ExportProgressPopup from '@/components/prescriber/ExportProgressPopup.vue';
    import SaveSearchPopup from '@/components/prescriber/SaveSearchPopup.vue';
    import Program from '../../models/Program';
    import SmoothReflow from '@/components/SmoothReflow.vue';
    import { postLotsArchivePrescriber, getLastPendingDenounce, getCustomerPrescriber, postLotsComparisonPrescriber, getProgramPrescriber } from '@/api/api';
    import { saveAs } from 'file-saver';
    import DownloadProgressToast from '@/components/prescriber/DownloadProgressToast.vue';
    import { BACKEND_URL } from '@/helpers/constants';
    import AuthModule from '@/store/AuthModule';
    import Customer from '@/models/Customer';

    @Component({
        components: {
            ProgramItem,
            ListLots,
            ProgramSearchComponent,
            // Lazy loading : Webpack créera un chunk séparé pour ce composant
            DenouncePopup: () => import('@/components/prescriber/DenouncePopup.vue'),
            SaveSearchPopup,
            SmoothReflow,
            ExportProgressPopup,
            DownloadProgressToast,
        },
    })
    export default class ProgramsList extends Vue {
        smoothReflowSettings = {
            transitionEvent: {
                selector: 'div',
                propertyName: 'opacity',
            },
        };
        tutoPopup: Boolean = false;
        optionned: boolean = false;
        headerSearchSelected: any = null;
        selected: string = 'programme';
        current: number = 1;
        metaPrograms: MetaDatatable | null = null;
        progressPopupVisible: boolean = false;
        popupDenounce: boolean = false;
        popupSaveSearch: boolean = false;
        end: number = 10;
        showConfirm: boolean = false;
        showManuel: boolean = false;
        extraDenouncePrograms: Program[] = [];
        denounceProgramsLoaded: boolean = false;

        downloadProgress = {
        visible: false,
        filename: '',
        progress: 0,
        downloadedBytes: 0,
        totalBytes: 0,
        speed: 0,
        completed: false,
        };

        async smartHeaderFetch(value: string) {
            if (!value) return [];
            if (/^\d+$/.test(value)) {
                return fetchProgramsPrescriberById(value);
            }
            return fetchProgramsPrescriber(value);
        }

        async onHeaderSearchChange(program: any) {
            this.headerSearchSelected = program || null;
            FiltersModule.setSelectedProgram(program && program.status !== 'sold' ? program : null);
            await FiltersModule.onFilters({
                ...FiltersModule.filters,
                program: program && program.status !== 'sold' ? program.id : undefined,
            });
            await Promise.all([ListModule.fetch(true), MapModule.fetch()]);
        }

        get filtersProgram() {
            return FiltersModule.filters.program;
        }

        @Watch('filtersProgram')
        onFiltersProgramChange() {
            this.syncHeaderSearch();
        }

        // Show the active program filter (set here or from the filter popup) in the header search
        syncHeaderSearch() {
            const search = this.$refs.headerSearch as any;
            const id = FiltersModule.filters.program;
            const selected = FiltersModule.selectedProgram;
            const active = id && selected && selected.id === id ? selected : null;
            this.headerSearchSelected = active;
            if (search) {
                search.setSelected(active);
            }
        }

        async saveSearch() {
            if(this.programsSelected.length === 0 && ListModule.lotsSelected.length === 0) {
                this.tutoPopup = true;
                return false;
            }
            this.popupSaveSearch = true
        }

        async saveDenounce() {
            if(this.programsSelected.length === 0 && ListModule.lotsSelected.length === 0) {
                this.tutoPopup = true;
                return false;
            }
            this.popupDenounce = true
        }

        get isRestricted() {
            return AuthModule.isRestricted
        }

        get userId(): number {
        return AuthModule.userID;
        }


        onExportCompleted() {
        this.progressPopupVisible = false;
        }



        async onSubmit() {
    let denounceLotIds: number[] = [];
    try {
        const raw = localStorage.getItem('denounce_selected_lot_ids');
        if (raw) denounceLotIds = JSON.parse(raw);
    } catch (e) {}

    if(this.programsSelected.length === 0 && ListModule.lotsSelected.length === 0 && denounceLotIds.length === 0) {
        this.tutoPopup = true;
        return false;
    }
    this.programsSelected.forEach(program => {
      if (
          program.id_import == '' ||
          program.id_import === null ||
          typeof program.id_import == 'undefined'
      ) {
        this.showManuel = true;
      }
    });
    this.showConfirm = true;
}



        async accept() {
            this.showManuel = false;
            this.showConfirm = false;

            // Petite pause pour s'assurer que tout est prêt
            await new Promise(resolve => setTimeout(resolve, 100));

            this.progressPopupVisible = false;
            await this.$nextTick();

            // Ouvrir la popup
            this.progressPopupVisible = true;

            // Lancer le téléchargement APRÈS que la popup soit ouverte
            setTimeout(() => {
                this.downloadLots();
            }, 100);
        }



        mounted() {
        const currentMeta = ListModule.meta;
        if (!currentMeta.orderBy) {
            ListModule.setMetaAction({
                ...currentMeta,
                orderBy: 'updated_at',
                orderWay: 'DESC'
            });
        }

        const userPrimaryColor = this.getUserPrimaryColor();
        if (userPrimaryColor) {
            this.setPrimaryColor(userPrimaryColor);
        }

        // ProgramsList is v-if — it mounts fresh every time the panel opens.
        // Keep the active program filter and show it in the search bar.
        this.$nextTick(() => this.syncHeaderSearch());

        ListModule.fetch();
    }



        get lotsSelected(): Lot[] {
            var isAllAvailable = false;
            var numberOfLot = ListModule.lotsSelected.length;
            var numberOfLotAv = 0;
            ListModule.lotsSelected.forEach(lot => {
                if (
                    lot.status == 'optionned'
                ) {
                    this.optionned = true;
                } else {
                    numberOfLotAv++;
                }
            });
            if (numberOfLot == numberOfLotAv) {
                this.optionned = false;
            }
            return ListModule.lotsSelected;
        }

        get AllLotsSelected(): number {
            return ListModule.lotsSelected.length;
        }

        async lotSelect(lot: Lot) {
            try {
                await ListModule.selectLot(lot);
            } catch (error) {
                const $vs = (this as any).$vs;
                $vs.notify({
                    color: 'danger',
                    position: 'top-right',
                    title: 'Erreur',
                    text: error.message,
                });
            }
        }

        get programsMax(): number {
            return ListModule.programsMax;
        }


        @Watch('loading')
        async onLoad() {
            const el = this.$refs.loading as HTMLElement;
            if (this.loading) {
                // @ts-ignore
                this.$vs.loading({
                    container: el,
                });
                this.denounceProgramsLoaded = false;
            } else {
                // @ts-ignore
                this.$vs.loading.close(el);
                if (!this.denounceProgramsLoaded) {
                    this.denounceProgramsLoaded = true;
                    await this.loadMissingDenouncePrograms();
                }
            }
        }

async loadMissingDenouncePrograms() {
    let denounceIds: number[] = [];
    let denounceLotIds: number[] = [];
    try {
        const raw = localStorage.getItem('denounce_selected_program_ids');
        if (raw) denounceIds = JSON.parse(raw);
    } catch (e) {}
    try {
        const raw = localStorage.getItem('denounce_selected_lot_ids');
        if (raw) denounceLotIds = JSON.parse(raw);
    } catch (e) {}
    if (denounceIds.length === 0) return;
    const loadedIds = ListModule.programs.map((p: Program) => p.id as number);
    const missingIds = denounceIds.filter(id => !loadedIds.includes(id));
    if (missingIds.length > 0) {
        const fetched: Program[] = [];
        for (const id of missingIds) {
            try {
                const { data } = await getProgramPrescriber(id);
                fetched.push(data);
            } catch (e) {}
        }
        this.extraDenouncePrograms = fetched;
    }
    if (denounceLotIds.length > 0) {
        const allPrograms = [
            ...ListModule.programs,
            ...this.extraDenouncePrograms,
        ];
        for (const program of allPrograms) {
            if (!(program as any).lots) continue;
            for (const lot of ((program as any).lots as any[])) {
                if (denounceLotIds.includes(lot.id) && !ListModule.lotsSelected.find((l: any) => l.id === lot.id)) {
                    try {
                        await ListModule.selectLot(lot);
                    } catch (e) {}
                }
            }
        }
    }
    await this.$nextTick();
    await new Promise(resolve => setTimeout(resolve, 300));
}

        get hasDenounceSelection(): boolean {
            try {
                const raw = localStorage.getItem('denounce_selected_program_ids');
                return !!raw && JSON.parse(raw).length > 0;
            } catch (e) {
                return false;
            }
        }

        clearDenounceSelection() {
            this.extraDenouncePrograms = [];
            this.denounceProgramsLoaded = false;
            ListModule.fetch();
        }


        clearDenounceData() {
        localStorage.removeItem('denounce_selected_program_ids');
        localStorage.removeItem('denounce_selected_lot_ids');
        this.clearDenounceSelection();
}


        get loading(): boolean {
            return ListModule.loading;
        }

        oldMeta: MetaDatatable | {} = this.metaPrograms || {};

        @Watch('metaPrograms', { deep: true })
        onMetaPrograms(newMeta: MetaDatatable) {
            ListModule.setMetaAction(newMeta);

            const oldMeta = this.oldMeta;
            this.oldMeta = cloneDeep(newMeta);

            const diff = differenceBetweenObjects(newMeta as any, oldMeta as any);
            const diffKeys = Object.keys(diff);

            const replaceProgramList = 'filters' in diff;

            const ignoredMetas = ['total', 'pages', 'filters'];
            const fusion = union(diffKeys, ignoredMetas);

            if (fusion.length === ignoredMetas.length) {
                return;
            }
        }

      get isSubscribed() {
        return AuthModule.isSubscriptionActive;
      }

        get programs() {
            let result: Program[];

            if (FiltersModule.filters.program) {
                result = ListModule.programs;
            } else {
                const bookmarkedIds = ListModule.programsBookmarked.map(
                    program => program.id,
                );
                const allPrograms = [
                    ...ListModule.programsBookmarked,
                    ...ListModule.programs.filter(
                        program => bookmarkedIds.indexOf(program.id) === -1,
                    ),
                ];

                let denounceIds: number[] = [];
                try {
                    const raw = localStorage.getItem('denounce_selected_program_ids');
                    if (raw) denounceIds = JSON.parse(raw);
                } catch (e) {}

                if (denounceIds.length === 0) {
                    result = allPrograms;
                } else {
                    const allWithExtra = [
                        ...allPrograms,
                        ...this.extraDenouncePrograms.filter(
                            (p: Program) => !allPrograms.find(x => x.id === p.id)
                        ),
                    ];
                    const selected = allWithExtra.filter(p => denounceIds.includes(p.id as number));
                    const rest = allWithExtra.filter(p => !denounceIds.includes(p.id as number));
                    result = [...selected, ...rest];
                }
            }

            // Deduplicate by ID to prevent Vue duplicate-key warnings
            const seen = new Set<number>();
            return result.filter(p => {
                if (seen.has(p.id as number)) return false;
                seen.add(p.id as number);
                return true;
            });
        }

        get programsBookmarked(): Program[] {
            return ListModule.programsBookmarked;
        }

        @Watch('meta')
        onMeta() {
            this.metaPrograms = this.meta;
        }

        get meta(): MetaDatatable {
            return ListModule.meta;
        }

        get privateMode() {
            return FiltersModule.privateMode;
        }

        sortBy(value: string) {
            let orderWay: 'DESC' | 'ASC' | null = null;
            let orderBy = null;

            if (this.metaPrograms) {
                if (this.metaPrograms.orderBy === value) {
                    switch (this.metaPrograms.orderWay) {
                        default:
                            orderBy = value;
                            orderWay = 'DESC';
                            break;
                        case 'DESC':
                            orderBy = value;
                            orderWay = 'ASC';
                            break;
                        case 'ASC':
                            orderBy = null;
                            orderWay = null;
                            break;
                    }
                } else {
                    orderBy = value;
                    orderWay = 'DESC';
                }

                this.metaPrograms = {
                    ...this.metaPrograms,
                    orderWay,
                    orderBy,
                };
            }
        }

        get programsSelected() {
            return ListModule.programsSelected;
        }

        get hasSelection(): boolean {
            return this.AllLotsSelected > 0 || this.programsSelected.length > 0;
        }

        @Watch('programsSelected')
        onProgramsSelected(newVal: Program[], oldVal: Program[]) {
            if (newVal.length !== oldVal.length) {
                const el = this.$refs.btnDenounce as HTMLElement;
                if (el) animateCSS(el, 'heartBeat');
            }
        }

        @Watch('AllLotsSelected')
        onLotsSelected(newVal: number, oldVal: number) {
            if (newVal !== oldVal) {
                const el = this.$refs.btnDenounce as HTMLElement;
                if (el) animateCSS(el, 'heartBeat');
            }
        }

        showMore() {
            if (this.metaPrograms) {
                this.meta.page += 1;
                this.end += 10;
            }
            ListModule.fetch();
        }

async downloadLots() {
    const filename = `Documents des lots.zip`;
    const $vs = (this as any).$vs;
    
    this.downloadProgress = {
        visible: true,
        filename: filename,
        progress: 0,
        downloadedBytes: 0,
        totalBytes: 0,
        speed: 0,
        completed: false,
    };
    
    try {
        let denounceLotIds: number[] = [];
        try {
            const raw = localStorage.getItem('denounce_selected_lot_ids');
            if (raw) denounceLotIds = JSON.parse(raw);
        } catch (e) {}

        const regularLotIds = ListModule.lotsSelected.map(lot => lot.id || -1);
        const allLotIds = [...new Set([...regularLotIds, ...denounceLotIds])];

        const requestBody = {
            lots: allLotIds,
        };
        
        const response = await fetch(`${BACKEND_URL}/api/prescriber/lots/archive`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${AuthModule.token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody),
        });
        
        if (!response.ok) {
            const errorText = await response.text();
            let errorMessage = 'Erreur lors du telechargement';
            try {
                const errorJson = JSON.parse(errorText);
                errorMessage = errorJson.message || errorMessage;
            } catch (e) {
                errorMessage = errorText || errorMessage;
            }
            throw new Error(errorMessage);
        }
        
        const contentLength = response.headers.get('content-length');
        const totalBytes = parseInt(contentLength || '0', 10);
        this.downloadProgress.totalBytes = totalBytes;

        const reader = response.body ? response.body.getReader() : null;
        if (!reader) {
            throw new Error('Unable to read response');
        }
        
        const chunks = [];
        let receivedBytes = 0;
        let lastTime = Date.now();
        let lastReceivedBytes = 0;
        
        while (true) {
            const { done, value } = await reader.read();
            
            if (done) break;
            
            chunks.push(value);
            receivedBytes += value.length;
            
            const progress = totalBytes > 0 ? (receivedBytes / totalBytes) * 100 : 0;
            
            const now = Date.now();
            if (now - lastTime > 500) {
                const timeDelta = (now - lastTime) / 1000;
                const bytesDelta = receivedBytes - lastReceivedBytes;
                const speed = bytesDelta / timeDelta;
                
                this.downloadProgress.speed = speed;
                lastTime = now;
                lastReceivedBytes = receivedBytes;
            }
            
            this.downloadProgress.downloadedBytes = receivedBytes;
            this.downloadProgress.progress = progress;
        }
        
        const blob = new Blob(chunks, { type: 'application/zip' });
        
        saveAs(blob, filename);
        
        this.downloadProgress.completed = true;
        this.downloadProgress.progress = 100;
        
        setTimeout(() => {
            this.downloadProgress.visible = false;
        }, 3000);
        
        $vs.notify({
            color: 'success',
            position: 'top-right',
            title: 'Telechargement termine',
            text: `${filename} a ete telecharge avec succes`,
        });
        
    } catch (error) {
        this.downloadProgress.visible = false;
        
        $vs.notify({
            color: 'danger',
            position: 'top-right',
            title: 'Erreur',
            text: error.message || 'Erreur lors du telechargement',
        });
        
        console.error('Download error:', error);
    }
}


        async generatePdfComparison() {
            let filename = `Comparaison_des_lots.pdf`;

            // APPELER L'API AFIN DE CRÉER UN PDF DE COMPARAISON DE 3 LOTS
            // NAME = POSTLOTSCOMPARISON
            postLotsComparisonPrescriber({
                lots: ListModule.lotsSelected.map(lot => lot.id || -1),
            })
                .then(({ data }) => {
                    saveAs(data, filename);
                })
                .catch(async error => {
                    const $vs = (this as any).$vs;
                    $vs.notify({
                        color: 'danger',
                        position: 'top-right',
                        title: 'Erreur',
                        text: JSON.parse(await error.response.data.text()).message,
                    });

                    if (error.response.status === 403) {
                        location.reload();
                    }


                });

        }


        
        setPrimaryColor(hexColor: string): void {
                const r: number = parseInt(hexColor.slice(1, 3), 16);
                const g: number = parseInt(hexColor.slice(3, 5), 16);
                const b: number = parseInt(hexColor.slice(5, 7), 16);
                
                document.documentElement.style.setProperty('--primary-color', hexColor);
        
                document.documentElement.style.setProperty('--vs-primary', `${r}, ${g}, ${b}`);
                document.documentElement.style.setProperty('--vs-personal_color', `${r}, ${g}, ${b}`);
            }

            getUserPrimaryColor(): string {
                const authJson = localStorage.getItem('auth')
                if (authJson) {
                    try {
                    const auth = JSON.parse(authJson)
                    return auth.personal_color || '#ff5733'
                    } catch {
                    return '#ff5733'
                    }
                }
                return '#ff5733'
                }

            initializeUserColor(): void {
                const personalColor = this.getUserPrimaryColor();
                this.setPrimaryColor(personalColor);
            }





            selectProgram(program: Program) {
                this.$emit('programClicked', program.id, program.name);
            }





    }
